import React from 'react';

export default function ServerError() {
    return <h1>500 ServerError</h1>;
}
